import { PanelDropdownItemDto } from "@oncolens/oncolens-ui/lib/components/BiomarkerResults/BiomarkerResults.api";
import { nanoid } from 'nanoid';
import { FaPlusCircle } from 'react-icons/fa';
import Biomarker from './Biomarker';
import { BiomarkerItem, useBiomarkerContext } from './PatientBiomarkerForm';

interface BiomarkerListProps {
	biomarkers: BiomarkerItem[];
	panelId: string;
}

const BiomarkerList = ({ biomarkers, panelId }: BiomarkerListProps) => {
  const context = useBiomarkerContext();

  return (
    <div className="grid grid-cols-1 gap-3 mx-3 mb-2 sm:grid-cols-3">
      {Boolean(biomarkers?.length) &&
				biomarkers.every((x) => x.id !== context.activeIds.biomarkerId) && (
        <h4 className="col-span-1 text-sm font-semibold text-gray-800 sm:col-span-3">Results</h4>
      )}
      {biomarkers?.map(
        (biomarker) =>
          (context.activeIds.biomarkerId === biomarker.id ||
						!context.activeIds.biomarkerId ||
						biomarkers.every((x) => x.id !== context.activeIds.biomarkerId)) && (
            <Biomarker key={`biomarker-${biomarker.id}`} data={biomarker} panelId={panelId} />
          )
      )}
      <AddBiomarkerButton biomarkers={biomarkers} panelId={panelId} />
    </div>
  );
};

const AddBiomarkerButton = ({ panelId, biomarkers }: BiomarkerListProps) => {
  const context = useBiomarkerContext();
  const handleAddBiomarker = () => {
    const newId = nanoid();

    context.setBiomarkerPanels((panelItems) =>
      panelItems.map((item) =>
        item.panel?.id === panelId
          ? ({
            ...item,
            panel: {
              ...item.panel,
              biomarkers: [
                ...(item.panel?.biomarkers ? item.panel.biomarkers : []),
                {
                  id: newId,
                  biomarkerName: undefined
                }
              ]
            }
					  } as PanelDropdownItemDto)
          : item
      )
    );

    context.setActiveIds((previous) => ({ ...previous, biomarkerId: newId }));
  };

  return (
    <>
      {!biomarkers?.some((x) => x.id === context.activeIds.biomarkerId) && (
        <button
          type="button"
          className="flex items-center justify-center h-24 text-gray-600 transition-colors duration-200 bg-white border-2 border-gray-300 border-dashed rounded-md hover:bg-gray-50 hover:border-gray-400 hover:text-gray-700"
          onClick={handleAddBiomarker}
        >
          <FaPlusCircle className="mr-2" /> Add biomarker...
        </button>
      )}
    </>
  );
};

export { BiomarkerList as default };
